module.exports = __webpack_public_path__ + "img/appstore.d9b12af1.svg";